import { useVoiceGuidanceContext } from "../../context/VoiceGuidanceContext";
import "./VoiceGuidanceToolbar.css";

/**
 * Global customer voice-assist toggle (fixed on small screens).
 */
export default function VoiceGuidanceToolbar({ embedded = false, variant = embedded ? "embedded" : "fixed" }) {
  const { supported, prefs, speaking, setEnabled, setAutoSpeak, stop } = useVoiceGuidanceContext();

  if (!supported) return null;

  const isToolbar = variant === "toolbar";

  return (
    <div
      className={`voice-toolbar voice-toolbar--${variant}`}
      role="region"
      aria-label="Voice guidance settings"
    >
      <div className="voice-toolbar__inner">
        <label className="voice-toolbar__toggle">
          <input
            type="checkbox"
            checked={prefs.enabled}
            onChange={(e) => setEnabled(e.target.checked)}
          />
          <span>Voice guide</span>
        </label>
        {prefs.enabled && !isToolbar ? (
          <label className="voice-toolbar__toggle voice-toolbar__toggle--sub">
            <input
              type="checkbox"
              checked={prefs.autoSpeak}
              onChange={(e) => setAutoSpeak(e.target.checked)}
            />
            <span>Auto-read steps</span>
          </label>
        ) : null}
        {speaking ? (
          <button type="button" className="voice-toolbar__stop" onClick={stop}>
            Stop
          </button>
        ) : null}
      </div>
      {prefs.enabled && !isToolbar ? (
        <p className="voice-toolbar__hint">Tap Listen on any guide card to hear instructions.</p>
      ) : null}
    </div>
  );
}
